<template>
  <div class="access_item_wrapper">
    <div class="access_item_label">
      <UiBaseIcon v-if="icon" v-bind="icon" class="access_item_label-icon" />
      <span class="access_item_label-text">{{ label }}</span>
    </div>

    <div class="options">
      <div v-for="(access, i) in accesesTypes" :key="i" class="option">
        <UiRadio
          :title="access.description"
          :name="label"
          :model="$attrs.value"
          v-bind="$attrs"
          :option-value="access.id"
          v-on="$listeners"
          @change="(value) => $emit('input', value)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import UiRadio from '@/components/UiRadio.vue'
import UiBaseIcon from '@/components/icons/UiBaseIcon.vue'

export default {
  components: {
    UiRadio,
    UiBaseIcon,
  },
  inheritAttrs: false,
  props: {
    /** Settings icon. Sizes, icon name, color */
    icon: {
      type: Object,
      default: () => ({}),
    },
    /** Label text of access field */
    label: {
      type: String,
      default: '',
      required: true,
    },
  },
  data() {
    return {
      accesesTypes: [
        {
          id: 'lock',
          description: 'Отключен',
        },
        {
          id: 'read',
          description: 'Чтение',
        },
        {
          id: 'edit',
          description: 'Запись',
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.access_item {
  &_wrapper {
    padding: rem(15px);
    border: 1px solid $color-gray-50;
    @include border_radius(5px);
    @include createFlex(flexbox, nowrap, row, space-between, center, center);
  }

  &_label {
    @include createFlex(flexbox, nowrap, row, flex-start, center, center);

    &-text {
      font-size: rem(12px);
      color: $color-gray-400;
    }
    &-icon {
      margin: 0 16px 0 0;
    }
  }
}
.options {
  @include createFlex(flexbox, nowrap, row, flex-end, center, center);

  .option {
    &:not(:last-child) {
      margin: 0 rem(4px) 0 0;
    }
  }
}
</style>
